export const getCookieName = (keyCookie: string) => {
    const cookies = document.cookie.split(';');
    const tokenCookie = cookies.find(cookie => cookie.trim().startsWith(keyCookie));
    if (tokenCookie) {
        const tokenCookieSplit = tokenCookie.split('=');
        return tokenCookieSplit[1].trim();
    }
    return '';
};
